import { Currency, ETHER, Token } from '@pancakeswap-libs/sdk'

export function currencyId(currency: Currency): string {
  // if (currency === ETHER) return '0xF4C9ad4cf3595ddaCDe89B6dE8d7cf8d948dA9DB'
  if(currency === ETHER ) return 'ETH'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}

export default currencyId
